// Generates the animated Cedys backdrop (drips, sparkles, ambient motes, bokeh).
// Shared by index.html (promo) and vote.html (ballot); pairs with css/effects.css.

const reduceMotion =
  window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function fill(id, count, build) {
  const container = document.getElementById(id);
  if (!container) return;
  for (let i = 0; i < count; i++) {
    container.appendChild(build());
  }
}

function createDrips() {
  fill("drips", Math.floor(window.innerWidth / 25), () => {
    const drip = document.createElement("div");
    drip.className = "drip";
    drip.style.left = `${Math.random() * 100}%`;
    drip.style.height = `${80 + Math.random() * 200}px`;
    drip.style.animationDuration = `${4 + Math.random() * 6}s`;
    drip.style.animationDelay = `${Math.random() * 10}s`;
    drip.style.opacity = 0.3 + Math.random() * 0.5;
    return drip;
  });
}

function createSparkles() {
  const types = ["gold", "warm", "deep"];
  fill("sparkles", Math.floor(window.innerWidth / 12), () => {
    const sparkle = document.createElement("div");
    sparkle.className = `sparkle ${types[Math.floor(Math.random() * types.length)]}`;
    const size = 2 + Math.random() * 6;
    sparkle.style.left = `${Math.random() * 100}%`;
    sparkle.style.width = `${size}px`;
    sparkle.style.height = `${size}px`;
    sparkle.style.animationDuration = `${3 + Math.random() * 4}s`;
    sparkle.style.animationDelay = `${Math.random() * 5}s`;
    return sparkle;
  });
}

function createAmbient() {
  fill("ambient", 30, () => {
    const particle = document.createElement("div");
    particle.className = "ambient";
    const size = 1 + Math.random() * 3;
    particle.style.left = `${Math.random() * 100}%`;
    particle.style.top = `${20 + Math.random() * 60}%`;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.animationDuration = `${3 + Math.random() * 4}s`;
    particle.style.animationDelay = `${Math.random() * 5}s`;
    return particle;
  });
}

function createGlitter() {
  // Scale with viewport area, but cap it — this page gets hammered on show night
  // and phones pay for every animated node.
  const area = window.innerWidth * window.innerHeight;
  const cap = window.innerWidth < 700 ? 55 : 130;
  const count = Math.max(24, Math.min(cap, Math.round(area / 9000)));

  fill("glitter", count, () => {
    const glitter = document.createElement("div");
    const warm = Math.random() < 0.28;
    glitter.className = warm ? "glitter warm" : "glitter";

    const size = (warm ? 17 : 10) + Math.random() * (warm ? 14 : 11);
    glitter.style.left = `${Math.random() * 100}%`;
    glitter.style.top = `${Math.random() * 100}%`;
    glitter.style.width = `${size}px`;
    glitter.style.height = `${size}px`;
    glitter.style.marginLeft = `${-size / 2}px`;
    glitter.style.marginTop = `${-size / 2}px`;
    // Long, staggered cycles so the field twinkles sporadically instead of pulsing.
    glitter.style.animationDuration = `${2.2 + Math.random() * 3.4}s`;
    glitter.style.animationDelay = `${Math.random() * 9}s`;
    return glitter;
  });
}

function createBokeh() {
  const colors = [
    "rgba(255, 192, 46, 0.15)",
    "rgba(250, 157, 8, 0.12)",
    "rgba(202, 157, 74, 0.1)",
    "rgba(226, 188, 114, 0.08)",
  ];
  fill("bokeh", 12, () => {
    const bokeh = document.createElement("div");
    bokeh.className = "bokeh";
    const size = 30 + Math.random() * 100;
    const color = colors[Math.floor(Math.random() * colors.length)];
    bokeh.style.left = `${Math.random() * 100}%`;
    bokeh.style.top = `${Math.random() * 100}%`;
    bokeh.style.width = `${size}px`;
    bokeh.style.height = `${size}px`;
    bokeh.style.background = `radial-gradient(circle, ${color} 0%, transparent 70%)`;
    bokeh.style.animationDuration = `${4 + Math.random() * 4}s`;
    bokeh.style.animationDelay = `${Math.random() * 4}s`;
    return bokeh;
  });
}

function build() {
  createDrips();
  createSparkles();
  createAmbient();
  createGlitter();
  createBokeh();
}

function clear() {
  ["drips", "sparkles", "ambient", "glitter", "bokeh"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.innerHTML = "";
  });
}

export function initEffects() {
  if (reduceMotion) {
    // css/effects.css already hides the moving layers; skip the DOM churn entirely.
    createBokeh();
    return;
  }

  build();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      clear();
      build();
    }, 250);
  });
}
